<template>
  <div v-bind:class="{ 'active': isOpened  }">
    <button class="filter__back" v-on:click.prevent="setOpened()" v-if="isOpened">
      <i class="daterange__goback--icon"></i>
      {{ $lang.filters.back }}
    </button>
    <div class="filter__header">
      <button v-on:click.prevent="toggleOpened()" class="filter__header--button" v-bind:class="{ 'filter__header--button-active': isOpened  }">
        {{ $lang.global.date_filter }}
        <div class="filter__header--icon"><i></i></div>
      </button>
    </div>

    <div v-if="isOpened" class="filter__list facet facet--date">
      <div class="facet__header">
        <button v-on:click.prevent="toggleOpened()" class="facet__header--close">
          <i></i>
        </button>
      </div>
      <div class="facet__date">
        <div class="facet__date--header date">
          <div class="date__row">
            <div class="date__inputs date__inputs--from">
              <label class="date__inputs--label">{{ $lang.filters.date.from }}</label>
              <input class="date__inputs--input" placeholder="dd.mm.yyyy" v-model.lazy="dateFrom" v-on:change="setNewRange(dateFrom, dateTo, 'from', start)" v-bind:class="{'date__inputs--input-notvalid': !isDateCheck}">
              <div class="date__inputs--error" v-if="!fromValid">{{ $lang.filters.date.not_valid }}</div>
            </div>
            <div class="date__inputs date__inputs--to">
              <label class="date__inputs--label">{{ $lang.filters.date.to }}</label>
              <input class="date__inputs--input" placeholder="dd.mm.yyyy" v-model.lazy="dateTo" v-on:change="setNewRange(dateFrom, dateTo, 'to', end)" v-bind:class="{'date__inputs--input-notvalid': !isDateCheck}">
              <div class="date__inputs--error" v-if="!toValid">{{ $lang.filters.date.not_valid }}</div>
            </div>
            <div class="date__info">
              <span class="date__info--text">{{ $lang.filters.date.placeholder }}</span>
            </div>
          </div>
          <div class="date__row date__row--submit">
            <div class="date__count">
              <span class="date__count--text">{{ $lang.filters.date.total_number }}:</span><span class="date__count--number" v-bind:lang="$lang.language" v-thousand-number="dateCount">{{ dateCount }}</span>
            </div>
            <div class="date__submit">
              <button class="date__submit--button" v-on:click="setDateRange()" v-bind:disabled="isNewValue || !fromValid || !toValid || !isDateCheck">
                {{ $lang.filters.submit }}
              </button>
            </div>
          </div>
        </div>
        <div class="facet__date--range">
          <div class="daterange">
            <div class="daterange__goback">
              <button v-if="dateArr.length > 0" v-on:click="popFromDateArr()" class="daterange__goback--button"><i class="daterange__goback--icon"></i></button>
            </div>
            <div class="daterange__date" v-if="dateRanges.length > 1">

              <div class="daterange__date--from">{{ dateRanges[0].start | moment('DD.MM.YYYY') }}</div>
              <div class="daterange__date--middle"></div>
              <div class="daterange__date--to">{{ dateRanges[dateRanges.length - 1].end | moment('DD.MM.YYYY') }}</div>
            </div>
            <div class="daterange__graph" v-if="dateRanges.length > 1">
              <div class="daterange__graph--up"></div>
              <div class="daterange__graph--middle"></div>
              <div class="daterange__graph--down"></div>
            </div>
            <ul class="daterange__list">
              <li v-for="date in dateRanges" class="daterange__list--item">
                <button class="daterange__item" v-on:click.prevent="setNewRange(date.start, date.end)"
                v-bind:class="{'disabled': date.results <= 0 || dateRanges.length <=1}">
                  <div class="daterange__item--from">
                    {{ date.start | moment('DD.MM.YYYY') }}
                  </div>
                  <div class="daterange__item--hyphen">
                    -
                  </div>
                  <div class="daterange__item--to">
                    {{ date.end | moment('DD.MM.YYYY') }}
                  </div>
                  <div class="daterange__item--count" v-bind:lang="$lang.language" v-thousand-number="date.results">
                    {{ date.results }}
                  </div>
                  <div class="daterange__item--link">
                    <i class="daterange__item--icon"></i>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="filter__content" v-if="isDateSet">
      <ul class="filter__params">
        <li class="filter__params--item filter__param">
          {{ $lang.filters.date.from }}: <span class="filter__param--date">{{ from | moment('DD.MM.YYYY') }}</span>
        </li>
        <li class="filter__params--item filter__param">
          {{ $lang.filters.date.to }}: <span class="filter__param--date">{{ to | moment('DD.MM.YYYY') }}</span>
        </li>
      </ul>
      <div class="filter__content--bottom">
        <button v-if="isDateSet" class="filter__params--clear" v-on:click="resetDateRange()">
          {{ $lang.filters.clear }}
        </button>
        <button v-if="isDateSet" class="filter__params--add" v-on:click.prevent="toggleOpened()">
          {{ $lang.filters.add }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as dateFilterModule from '../../scripts/modules/date-filter'
import * as searchModule from '../../scripts/modules/search'
import { mapGetters } from 'vuex'

export default {
  name: 'filter',
  methods: {
    setOpened: function() {
      // opens and closes subfilters dropdown
      return (!this.isOpened) ? this.$store.commit('SET_FILTER_BOX', this.name) : this.$store.commit('SET_FILTER_BOX', false)
    },
    toggleOpened: function() {
      this.setOpened()
      return this.$store.commit('SET_IS_FILTER_BOX', this.isOpened)
    },
    setDateRange: function() {
      if (this.fromValid && this.toValid) {
        dateFilterModule.setDateRange()
        // close the subfilters box
        this.setOpened()
        // clears dates array
        this.$store.commit('RESET_DATE_ARR')
      }
    },
    resetDateRange: function() {
      this.clearDateFileds()
      dateFilterModule.resetDateRange()
    },
    clearDateFileds: function() {
      // clears inputs
      this.dateFrom = ''
      this.dateTo = ''

      // reset date validation
      dateFilterModule.setValidDates()

      // clears dates array
      this.$store.commit('RESET_DATE_ARR')
    },
    setNewRange: function(startDate, endDate, type, valueDefault) {
      if (!(type && valueDefault)) {
        dateFilterModule.setValidDates()
      }

      if (this.fromValid && this.toValid) {
          // new values from range to inputs
          this.dateFrom = startDate
          this.dateTo = endDate

          // fix date format
          startDate = dateFilterModule.momentDateValid(startDate)
          endDate = dateFilterModule.momentDateValid(endDate)
          //valueDefault = dateFilterModule.momentDateValid(valueDefault)

          // validation of entered range
          if (type && valueDefault) {
            if (type == 'from') {
              this.dateFrom = dateFilterModule.momentDateRangeValidDateFrom(startDate, this.end, valueDefault)
              startDate = dateFilterModule.momentDateRangeValidDateFrom(startDate, this.end, valueDefault)
            } else {
              this.dateTo = dateFilterModule.momentDateRangeValidDateTo(this.start, endDate, valueDefault)
              endDate = dateFilterModule.momentDateRangeValidDateTo(this.start, endDate, valueDefault)
            }
          }

        if (dateFilterModule.momentCheckDateFromDateTo(startDate, endDate)) {
          // sets active range date to store
          dateFilterModule.setDateActive(startDate, endDate)

          // counts new gap between dates
          dateFilterModule.setDateGap(startDate, endDate)

          // puts dante range in date array for back button
          dateFilterModule.setToArr(startDate, endDate)

          // reloads date ranges
          searchModule.loadDateRanges()
        }
      }
    },
    // removes last date from date array and reload ranges
    popFromDateArr: function() {
      this.$store.commit('POP_FROM_DATE_ARR')
      searchModule.loadDateRanges()
    }
  },
  computed: {
    isOpened: {
      get: function() {
        return (this.$store.getters.GET_FILTER_BOX == this.name)
      },
      set: function() {
        return false
      }
    },
    dateFrom: {
      get () {
        let value = this.$store.getters.GET_DATE_FROM
        let date = value.split('-')
        date = date[2] + '.' + date[1] + '.' + date[0]
        return (this.$store.getters.GET_VALID_DATE_FROM) ? date : value
      },
      // sets new date value in store
      set (value) {
        let defaultValue = (this.fromActive) ? this.fromActive : this.start
        this.$store.commit('SET_DATE_FROM', dateFilterModule.isDate(value, 'FROM', defaultValue))
      }
    },
    dateTo: {
      get () {
        let value = this.$store.getters.GET_DATE_TO
        let date = value.split('-')
        date = date[2] + '.' + date[1] + '.' + date[0]
        return (this.$store.getters.GET_VALID_DATE_TO) ? date : value
      },
      // sets new date value in store
      set (value) {
        let defaultValue = (this.toActive) ? this.toActive : this.end
        this.$store.commit('SET_DATE_TO', dateFilterModule.isDate(value, 'TO', defaultValue))
      }
    },
    dateCount: {
      get () {
        return this.$store.getters.GET_DATE_COUNT
      }
    },
    isNewValue() {
      // checks if current dates in form are equal to set in filter or to default date values
      return ((this.dateFrom == this.from) && (this.dateTo == this.to)) ||
             (!this.isDateSet && this.dateFrom == this.start && this.dateTo == this.end)
    },
    ...mapGetters({
      from: 'GET_DATE_FROM_STATIC',
      to: 'GET_DATE_TO_STATIC',
      fromActive: 'GET_DATE_FROM_ACTIVE',
      toActive: 'GET_DATE_TO_ACTIVE',
      fromValid: 'GET_VALID_DATE_FROM',
      toValid: 'GET_VALID_DATE_TO',
      // date ranges for current dates
      dateRanges: 'GET_FACET_DATE_RANGES',
      // checks if date filter is set in facets
      isDateSet: 'GET_IS_DATE_SET',
      dateValid: 'GET_IS_DATE_VALID',
      isDateCheck: 'GET_IS_DATE_CHECK',
      datePreviousValid: 'GET_IS_PREVIOUS_DATE_VALID',
      dateGap: 'GET_DATE_GAP',
      start: 'GET_DATE_START',
      end: 'GET_DATE_END',
      // array of dates for back button
      dateArr: 'GET_DATE_ARR'
    })
  }
}
</script>



// WEBPACK FOOTER //
// SearchDateFilter.vue?22b2d554